import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  /**
 * Sets the value for a given key in the local storage.
 * The value is stored as a stringified JSON object.
 *
 * @param key The key to store the value under.
 * @param value The value to store.
 */
  public setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Retrieve the item from local storage and parse it as JSON
   * @param key 
   * @returns 
   */
  public getItem(key: string): any {
    const item = localStorage.getItem(key);
    
    /** Parse JSON */
    return item ? JSON.parse(item) : null;
  }

  /**
   * Retrieve the item from local storage and parse it as JSON
   * @param key 
   */
  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
